<template>
  <div>
    <v-container
      :style="{
        padding: $vuetify.breakpoint.mobile ? undefined : '0px 0px 0px 110px',
      }"
    >
      <v-card flat color="transparent">
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field v-model="search" single-line solo hide-details>
                <template #label> <v-icon>search</v-icon> ค้นหา</template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="status_selected"
                :items="status"
                item-value="status"
                item-text="text"
                label="สถานะ"
                solo
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" md="2" class="d-flex justify-center align-center">
              <PopupAddSurvey :trial="trial" v-if="limitSurvey" />
            </v-col>
            <v-col
              v-if="false"
              cols="12"
              md="2"
              class="d-flex justify-center align-center"
            >
              <PopupRequestOtherSurvey />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <SurveyCard
        :surveylist="storeSurveylist"
        :trial="trial"
        :limitSurvey="limitSurvey"
      />
    </v-container>
  </div>
</template>

<script>
import PopupAddSurvey from "../../components/SurveyUI/PopupAddSurvey";
import PopupRequestOtherSurvey from "../../components/SurveyUI/PopupRequestOtherSurvey.vue";
import SurveyCard from "../../components/SurveyUI/SurveyCard";
export default {
  components: { PopupAddSurvey, SurveyCard, PopupRequestOtherSurvey },
  data: () => ({
    search: "",
    status_selected: "all",
    trial: false,
    status: [
      { text: "ทั้งหมด", status: "all" },
      { text: "เปิดใช้งาน", status: true },
      { text: "ปิดใช้งาน", status: false },
    ],
  }),
  created() {
    this.$store.dispatch("getSurvey");
    this.$store.dispatch("getTrial").then((resp) => {
      if (resp.data.ableTrial) {
        this.trial = true;
      }
    });
  },
  computed: {
    limitSurvey() {
      let countOwnerOnly = this.$store.state.surveylist.filter((survey) =>
        survey.members.find(
          (member) =>
            member.displayName ===
              this.$jwtDecode(
                this.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token")
              ).displayName && member.roleID === "Owner"
        )
      );
      return (
        this.$store.state.user_permission.limitSurvey > countOwnerOnly.length
      );
    },
    storeSurveylist() {
      let surveylist = this.$store.state.surveylist;
      if (this.status_selected !== "all") {
        surveylist = surveylist.filter(
          (search) => search.surveyStatus === this.status_selected
        );
      }
      if (typeof this.search != "object") {
        if (surveylist.length > 0) {
          let filter = surveylist.filter(
            (search) =>
              new RegExp(this.search.toUpperCase()).test(
                search.surveyName.toUpperCase()
              ) ||
              new RegExp(this.search.toUpperCase()).test(
                search.surveyDetail.toUpperCase()
              )
          );
          return filter;
        }
      }
      return surveylist;
    },
    storeQuestion() {
      return this.$store.state.allquestion;
    },
  },
};
</script>
